<template>
  <div class="mobile-date">
    <UIDatepicker :locale="location.locale" :value="startTime" @update="changeDate" :options="{ time_24hr: location.twentyFourHourTime }" />
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UIDatepicker from '@/core/shared/components/ui/UIDatepicker';
import DateHelper from '@/core/shared/helpers/DateHelper';
import moment from 'moment-timezone';

@Component({
  components: {
    UIDatepicker,
  },
  props: {
    startTime: {
      type: String,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    currentTime: {
      type: String,
      required: true,
    },
  },
})
export default class MobileDate extends Vue {
  changeDate (selectedDate) {
    if (DateHelper.dateMatch(selectedDate, this.currentTime)) {
      this.$emit('setStartingTimeNow');
    } else {
      const startTimeMoment = moment(this.startTime);
      const dateMoment = moment(selectedDate).set({
        hours: startTimeMoment.hours(),
        minutes: startTimeMoment.minutes(),
        seconds: startTimeMoment.seconds(),
      });
      this.$emit('setStartingTime', dateMoment.format());
    }
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.mobile-date {
  width: 100%;

  & .label {
    margin-bottom: var(--spacingXS);
  }

}
</style>

<style>
@import 'core/shared/styles';

.date-selection-flatpickr-mobile.flatpickr-input.flatpickr-mobile {
  font-size: 1.4rem;
  line-height: 2rem;
  font-family: var(--fontSansSerif);
  font-weight: 400;
}
</style>
